import { Component, OnInit } from '@angular/core';

export interface Management {
  members: {
    name: string;
    position: string;
    profile_picture?: string;
  }[];
  division_name: string;
  documents?: {
    name: string;
    url: string;
  }[];
}

@Component({
  selector: 'app-gcg',
  templateUrl: './gcg.component.html',
  styleUrls: ['./gcg.component.scss'],
})
export class GcgComponent implements OnInit {
  boards: Management[] = [
    {
      division_name: 'COMPANY.GCG.BOARD_OF_COMMISSIONERS',
      members: [
        {
          name: 'Yune Marketatmo',
          position: 'COMPANY.GCG.CHIEF_COMMISSIONER',
          profile_picture: 'pp_yune_marketatmo.png',
        },
        {
          name: 'Leonardus Chrisbiantoro',
          position: 'COMPANY.GCG.INDEPENDENT_COMMISSIONER',
          profile_picture: 'pp_leonardus_chrisbiantoro.png',
        },
        // {
        //   name: "Martha Rebecca",
        //   position: "COMPANY.GCG.CHIEF_COMMISSIONER",
        //   profile_picture: "pp_martha_rebecca.png"
        // },
        // {
        //   name: "Wahyudi",
        //   position: "COMPANY.GCG.COMMISSIONER",
        //   profile_picture: "pp_wahyudi_raihan.png"
        // },
        // {
        //   name: "Raihan Nabil Zakiy",
        //   position: "COMPANY.GCG.INDEPENDENT_COMMISSIONER",
        //   profile_picture: "pp_nabil_zakiy.png"
        // }
      ],
    },
    {
      division_name: 'COMPANY.GCG.BOARD_OF_DIRECTORS',
      members: [
        {
          name: 'Hermansjah Haryono',
          position: 'COMPANY.GCG.PRESIDENT_DIRECTOR',
          profile_picture: 'pp_hermansjah_haryono.png',
        },
        {
          name: 'Erwin Tanjung',
          position: 'COMPANY.GCG.DIRECTOR',
          profile_picture: 'pp_erwin_tanjung.png',
        },
        {
          name: 'Moh Mustaghfirin',
          position: 'COMPANY.GCG.DIRECTOR',
          profile_picture: 'pp_mustaghfirin.png',
        },
        {
          name: 'Rudy Chandra',
          position: 'COMPANY.GCG.DIRECTOR',
          profile_picture: 'pp_rudy_chandra.png',
        },
      ],
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
